import React, { useEffect, useRef, useState } from "react";
import addiconsDetails from "../../../../Assets/addIconsDetails.svg";
import saveimg from "../../../../Assets/downloadcv.png";
import print from "../../../../Assets/print.svg";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import "../CostomNewsSearchDetails/CustomNewsSearchDetails.css";
import { APIDataUrl, APITokenUrl, GetUserId } from "../../../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import halflines from "../../../../Assets/halflines.svg";
import CloseIcon from "@mui/icons-material/Close";
import search from "../../../../Assets/search.svg";
import { useReactToPrint } from "react-to-print";
import LabelInput from "../../../LabelInputFields/Index";
import Loader from "../../../Loader/Loader";
import html2pdf from "html2pdf.js";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeywordFilterModal from "../../../CompetitiveIntelligence/KeywordFilterModal";
import { CloseOutlined } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
const CustomNewsSearchDetails = ({
  dataForInformation,
  generatePdf,
  
  
}) => {
  let localData = JSON.parse(localStorage?.getItem("cns"));
  const [keywordAddModal, setKeywordAddModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dateOrderOne, setDateOrderOne] = useState("desc");
  const [skipOne, setSkipOne] = useState(0);
  const [loadOne, setLoadOne] = useState(true);
  const [selectedCustomSearch, setSelectedCustomSearch] = useState(
    localData?.id || null,
  );
  const [allCustomSearchList, setAllCustomSearchList] = useState([]);
  const [value, setValue] = useState("");
  const [newsId, setNewsId] = useState("");
  const [allTableInfo, setAllTableInfo] = useState(false);
  const [feedBoxOne, setFeedBoxOne] = useState(localData?.data || []);
  const { id, tag } = useParams();
  const [searchOneApi, setSearchOneApi] = useState(false);
  const [saveSearchOne, setSaveSearchOne] = useState([""]);
  const [allExpanded, setAllExpanded] = useState(false);
  const [expandedSummaryOne, setExpandedSummaryOne] = useState({});
  const [openSearchOne, setOpenSearchOne] = useState(false);
  const [customSearchData, setCustomSearchData] = useState([]);
  const [keywordAddModalOne, setKeywordAddModalOne] = useState(false);
  const [keywordListOne, setKeywordListOne] = useState([]);
  const [keywordSelectedOne, setKeywordSelectedOne] = useState([]);
  const orgId = id;
  const boxOneRef = useRef();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    borderRadius: "8px",
  };

  const handleCustomSearchData = () => {
    setLoading(true);
    axios
      .post(
        `${APIDataUrl()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
        {},
        {
          headers: {
            "access-control-allow-origin": "*",
            "X-API-Key": APITokenUrl(),
          },
        },
      )
      .then((res) => {
        setLoading(false);
        const data = res?.data?.data || [];
        const filtered = data
          .filter((i) => i?.request_type === "custom_search")
          .filter(
            (i) =>
              new Date(i.track_until).toISOString().split("T")[0] >
              new Date().toISOString().split("T")[0],
          );
        setAllCustomSearchList(filtered);
        setKeywordAddModal(true);

        const filteredData = data
          ?.filter((i) => i?.person_id === null)
          ?.filter((item) => item?.org_id?.toString() == orgId?.toString());

        if (filteredData?.length) {
          setNewsId(filteredData?.length);
          // getNews()
        } else {
          setNewsId();
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Failed to fetch custom search data.");
      });
  };

  const getNews = (type, requestIdParam = null) => {
    setLoading(true);
    let keywordQuery = `${keywordSelectedOne?.length ? "&tags=" : ""}${keywordSelectedOne?.length ? keywordSelectedOne : ""}`;
    setSelectedCustomSearch(requestIdParam || selectedCustomSearch);
    const requestId = requestIdParam || selectedCustomSearch;
    axios
      .post(
        `${APIDataUrl()}/v1/get_news?sort_order=${dateOrderOne}&document_type=news&request_id=${customSearchData?.request_id}&limit=10&skip=${type === "date" ? 0 : skipOne}${keywordQuery}`,
        {},
        {
          headers: {
            "access-control-allow-origin": "*",
            "X-API-Key": APITokenUrl(),
          },
        },
      )
      .then((res) => {
        const news = res?.data || [];

        if (news?.items?.length < 10 || news.data?.length < 10) {
          setLoadOne(false);
        } else {
          setLoadOne(true);
        }
        if (type === "date") {
          setFeedBoxOne(news?.items);
          localStorage.setItem(
            "cns",
            JSON.stringify({ id: requestId, data: news?.items }),
          );
        } else {
          setFeedBoxOne((prev) => [...prev, ...news?.items]);
          localStorage.setItem(
            "cns",
            JSON.stringify({
              id: requestId,
              data: [...feedBoxOne, ...news?.items],
            }),
          );
        }
        setKeywordAddModal(false);
        setAllTableInfo(true);
        setKeywordListOne(res?.data?.tags || []);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || "Failed to fetch news.");
      });
  };
  useEffect(() => {
    if (keywordSelectedOne?.length && !searchOneApi) {
      getNews("date");
    } else {
    }
  }, [keywordSelectedOne?.length]);
  const getCustomSearchFeed = () => {
    setLoading(true);
    const data = {};
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/get_custom_search_feed?user_id=${GetUserId()}&org_id=${orgId}`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        setCustomSearchData(response.data.data[0]);
        // getNews()
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    getCustomSearchFeed();
  }, []);

  useEffect(() => {
    if (customSearchData?.request_id) {
      getNews("date");
    }
  }, [customSearchData]);

  const saveContentFeed = (keyword) => {
    setLoading(true);
    const fields = keyword;
    const data = {
      id: 0,
      user_id: GetUserId(),
      people_id: 0,
      request_id: fields?.request_id,
      org_id: orgId,
      context_box: 4,
      location: "",
      tags: "",
      industry: fields?.industry,
      document_type: fields?.request_type,
    };

    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_feed_box`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        setAllTableInfo(true);
        setKeywordAddModal(false);
        getNews(keyword);
        // handleClose();
        // getContentFeed(value, "save");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const truncateText = (text) => {
    return text?.length > 13 ? text?.slice(0, 13) + "..." : text;
  };
  const handleChangeFeedBoxOne = (event) => {
    setDateOrderOne(event.target.value);
  };
  // useEffect(() => {
  //   getNews()
  // }, [customSearchData])

  useEffect(() => {
    if (skipOne > 0 && !searchOneApi) {
      getNews();
    } else if (skipOne > 0 && searchOneApi) {
      handleSearchSave();
    }
  }, [skipOne]);
  useEffect(() => {
    if (dateOrderOne && !searchOneApi && selectedCustomSearch) {
      setSkipOne(0);
      getNews("date");
    }
  }, [dateOrderOne, searchOneApi]);
  useEffect(() => {
    if (saveSearchOne?.length > 2) {
      const timer = setTimeout(() => {
        handleSearchSave(1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveSearchOne]);
  const handleSearchSave = (e) => {
    const data = [saveSearchOne];
    const skipVal = skipOne;
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
        "Content-Type": "application/json",
      },
      data: data,
      url: `${APIDataUrl()}/v1/search_news?&request_id=${selectedCustomSearch}&limit=10&skip=${e == 1 ? 0 : skipVal}&search_term=${saveSearchOne}`,
    };
    axios(options)
      .then((response) => {
        if (response?.data?.length < 10) {
          setLoadOne(false);
        } else {
          setLoadOne(true);
        }
        if (e == 1) {
          setSearchOneApi(true);
          setFeedBoxOne(response.data);
          localStorage.setItem(
            "cns",
            JSON.stringify({ id: selectedCustomSearch, data: response.data }),
          );
        } else {
          setFeedBoxOne((prev) => [...prev, ...response.data]);
          localStorage.setItem(
            "cns",
            JSON.stringify({
              id: selectedCustomSearch,
              data: [...feedBoxOne, ...response.data],
            }),
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (saveSearchOne?.length > 3) {
      handleSearchSave(1);
    }
  }, [saveSearchOne]);

  const ExpandAllSummary = (value) => {
    setAllExpanded(value);
    let data = feedBoxOne?.reduce((acc, _, index) => {
      acc[index] = value;
      return acc;
    }, {});
    setExpandedSummaryOne(data);
  };
  const toggleSummaryOne = (index) => {
    setExpandedSummaryOne((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const HandlePrint = useReactToPrint({
    content: () => boxOneRef.current,
  });
  const handleToPDF = (item) => {
    const content = boxOneRef.current;
    const options = {
      filename: "newsFeed.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        format: "letter",
        orientation: "portrait",
      },
    };
    html2pdf().set(options).from(content).save();
  };
  const initialData = (item) => {
    const data = item?.split(" ");
    return `${data?.[0]?.charAt(0).toUpperCase() || ""}${
      data?.[1]?.charAt(0).toUpperCase() || ""
    }`;
  };
  const handleRemoveFeed = () => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/delete_feed_box?box_id=${customSearchData?.request_id}`,
    };
    axios(options)
      .then((e) => {
        setLoading(false);
        setAllTableInfo(false);
        // getContentFeed(item?.content_box_id, "del");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handleRemoveTags = (item) => {
    let data = keywordSelectedOne.filter(
      (keyword) => keyword.toLowerCase() !== item.toLowerCase(),
    );
    setKeywordSelectedOne(data);
    if (!data?.length) {
      getNews("date");
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
    <div
      className="main-CustomNewsSearchDetails"
      style={{ position: "relative" }}
    >
      {allTableInfo ? (
        <>
          <div className="add-contents-cards">
            {allTableInfo ? (
              <>
                {" "}
                {feedBoxOne ? (
                  <div
                    className="CI-cards-content"
                    style={{ pageBreakInside: "avoid" }}
                  >
                    <div
                      className="adding-content"
                      style={{ pageBreakInside: "avoid" }}
                    >
                      <div className="two-head-comp">
                        <div className="result-tags-icon-comp">
                          <div className="checkbox-result-tag-comp">
                            {/* <input type="checkbox" /> */}
                            <p className="result-comp">
                              {feedBoxOne?.length || 0}{" "}
                              {feedBoxOne?.length > 1
                                ? "Results"
                                : "Result"}
                            </p>
                            {/* <p className='ai-tags-comp'>AI Tags</p> */}
                          </div>
                          <div>
                            <Tooltip
                              title={
                                feedBoxOne?.boxData?.org_id
                                  ? feedBoxOne.boxData.org_name
                                  : feedBoxOne?.boxData?.first_name &&
                                      feedBoxOne?.boxData?.last_name
                                    ? `${feedBoxOne.boxData.first_name} ${feedBoxOne.boxData.last_name}`
                                    : feedBoxOne?.boxData?.location
                                      ? feedBoxOne?.boxData?.location
                                      : feedBoxOne?.boxData?.tags
                              }
                              arrow
                              placement="top"
                            >
                              <p className="card-heading-top">
                                {feedBoxOne?.boxData?.org_id
                                  ? truncateText(
                                      feedBoxOne.boxData.org_name,
                                    )
                                  : feedBoxOne?.boxData?.first_name &&
                                      feedBoxOne?.boxData?.last_name
                                    ? truncateText(
                                        `${feedBoxOne.boxData.first_name} ${feedBoxOne.boxData.last_name}`,
                                      )
                                    : feedBoxOne?.boxData?.location
                                      ? truncateText(
                                          feedBoxOne?.boxData?.location,
                                        )
                                      : truncateText(
                                          feedBoxOne?.boxData?.tags,
                                        )}
                              </p>
                            </Tooltip>
                          </div>
                          <div
                            style={{ display: false ? "none" : "flex" }}
                            className="copy-threedot-comp"
                          >
                            <Button
                              className="de_next"
                              // onClick={() => { setFeedBoxOne([]); setAllTableInfo(false); setValue(""); localStorage.removeItem("cns") }}
                              onClick={handleRemoveFeed}
                            >
                              Clear{" "}
                            </Button>
                            <img src={print} alt="" onClick={HandlePrint} />
                            <img
                              src={saveimg}
                              alt=""
                              onClick={() => handleToPDF(1)}
                            />
                            {/* <CloseIcon
                      className="threedot-icon-comp"
                      onClick={() => handleRemoveFeed(feedBoxOne?.boxData)}
                    /> */}
                          </div>
                        </div>
                        {feedBoxOne?.length ? (
                          <div
                            className="result-date-icon-comp"
                            style={{
                              display: "flex",
                              pageBreakInside: "avoid",
                            }}
                          >
                            <div className="checkbox-result-tag-comp">
                              <img src={halflines} alt="" />
                              <p className="sorted-by-comp">
                                Sorted by date:
                              </p>
                              <FormControl
                                sx={{ m: 1, minWidth: 120 }}
                                className="date-comp-dropdown"
                              >
                                <Select
                                  className="date-comp-select"
                                  value={dateOrderOne}
                                  onChange={handleChangeFeedBoxOne}
                                  displayEmpty
                                  inputProps={{
                                    "aria-label": "Without label",
                                  }}
                                >
                                  {/* <MenuItem value="" className='date-comp-menuitem'>
                                  <em className='date-comp-em'>Date</em>
                                </MenuItem> */}
                                  <MenuItem
                                    value="asc"
                                    className="date-comp-em"
                                  >
                                    Ascending{" "}
                                  </MenuItem>
                                  <MenuItem
                                    value="desc"
                                    className="date-comp-em"
                                  >
                                    Descending{" "}
                                  </MenuItem>
                                </Select>
                              </FormControl>
                              {allExpanded ? (
                                <div
                                  onClick={() => ExpandAllSummary(false)}
                                  style={{
                                    display: generatePdf ? "none" : "flex",
                                  }}
                                  className="news_all_expand"
                                >
                                  Collapse All
                                </div>
                              ) : (
                                <div
                                  onClick={() => ExpandAllSummary(true)}
                                  style={{
                                    display: generatePdf ? "none" : "flex",
                                  }}
                                  className="news_all_expand"
                                >
                                  Expand All
                                </div>
                              )}

                              <div style={{ position: "relative" }}>
                                <button
                                  className="keyword-filter-btn"
                                  disabled={searchOneApi}
                                  onClick={() =>
                                    setKeywordAddModalOne(true)
                                  }
                                >
                                  Keyword Filter <ArrowDropDownIcon />
                                </button>
                                {keywordAddModalOne === true ? (
                                  <KeywordFilterModal
                                    setKeywordAddModal={
                                      setKeywordAddModalOne
                                    }
                                    setFeedBox={setKeywordSelectedOne}
                                    feedBox={keywordSelectedOne}
                                  />
                                ) : null}
                              </div>
                            </div>
                            <div className="search_news_container">
                              <div
                                style={{
                                  display: generatePdf ? "none" : "flex",
                                }}
                                className={
                                  openSearchOne
                                    ? "wrap-search-news active"
                                    : "wrap-search-news"
                                }
                              >
                                <input
                                  type="text"
                                  className={
                                    openSearchOne
                                      ? "input_search_news active"
                                      : "input_search_news"
                                  }
                                  placeholder="Search..."
                                  value={saveSearchOne}
                                  onChange={(e) =>
                                    setSaveSearchOne(e?.target?.value)
                                  }
                                  // autoFocus
                                />
                                {openSearchOne ? (
                                  <CloseIcon
                                    className="threedot-icon-comp"
                                    onClick={() => {
                                      setOpenSearchOne(false);
                                      setSearchOneApi(false);
                                      setSaveSearchOne("");
                                      // getNews(feedBoxOne?.boxData, "date");
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={search}
                                    alt=""
                                    onClick={() => {
                                      setOpenSearchOne(true);
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div ref={boxOneRef}>
                        {keywordSelectedOne?.length ? (
                          <div className="display-kw-ci">
                            {keywordSelectedOne?.map((item) => (
                              <div className="crie_selected_names">
                                {item}{" "}
                                <CloseOutlined
                                  onClick={() => handleRemoveTags(item)}
                                />
                              </div>
                            ))}
                          </div>
                        ) : null}
                        {feedBoxOne?.length ? (
                          <>
                            {feedBoxOne?.map((articleData, index) => (
                              <div
                                key={index}
                                className="rest-cont"
                                style={{ pageBreakInside: "avoid" }}
                              >
                                <div className="orbit-circle-text-comp">
                                  <div className="jo-icon-comp">
                                    <p>
                                      {dataForInformation?.name
                                        ? initialData(
                                            dataForInformation?.name,
                                          )
                                        : dataForInformation?.name}
                                    </p>
                                  </div>
                                  <div className="date-name-csoon">
                                    <div>
                                      <p className="orbit-name-comp">
                                        {articleData?.article?.title
                                          ?.length > 100
                                          ? articleData?.article?.title.slice(
                                              0,
                                              articleData?.article?.title
                                                .slice(0, 100)
                                                .lastIndexOf(" "),
                                            ) + "..."
                                          : articleData?.article?.title}
                                      </p>
                                    </div>
                                    <div className="both-news-time-comp">
                                      <p className="news-comp">
                                        <a
                                          href={articleData?.article?.url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {articleData?.article?.url
                                            ? articleData.article.url.split(
                                                "https://",
                                              )[1]?.length > 50
                                              ? articleData.article.url
                                                  .split("https://")[1]
                                                  .slice(0, 50) + "..."
                                              : articleData.article.url.split(
                                                  "https://",
                                                )[1]
                                            : ""}
                                        </a>
                                        |
                                      </p>
                                      <p className="today-comp">
                                        {new Date(
                                          articleData?.article?.date,
                                        ).toLocaleDateString("en-US", {
                                          month: "long",
                                          day: "numeric",
                                          year: "numeric",
                                        })}
                                        {/* {articleData?.article?.date} */}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="content-pera-comp">
                                  <p className="bold-content-pera-comp">
                                    {expandedSummaryOne[index] ? (
                                      <>
                                        {articleData.summary}
                                        {articleData.summary.length >
                                          400 && (
                                          <span
                                            onClick={() =>
                                              toggleSummaryOne(index)
                                            }
                                            className="see-more-btn"
                                            style={{
                                              color: "#001A54",
                                              cursor: "pointer",
                                              textDecoration: "none",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            Show Less
                                          </span>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {articleData.summary.length > 400
                                          ? `${articleData.summary.slice(0, articleData.summary.lastIndexOf(" ", 400))}`
                                          : articleData.summary}
                                        {articleData.summary.length >
                                          400 && (
                                          <span
                                            onClick={() =>
                                              toggleSummaryOne(index)
                                            }
                                            className="see-more-btn"
                                            style={{
                                              color: "#001A54",
                                              cursor: "pointer",
                                              textDecoration: "none",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            See More
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </p>
                                  <div className="Intersect-jb-nf-comp">
                                    {articleData?.tags?.map((tag, idx) => (
                                      <p key={idx}>{tag}</p>
                                    ))}
                                    {/* <p className="save-button-dash" onClick={() => setOpenTagModal({ articleData: articleData, data: feedBoxOne?.boxData?.content_box_id })}>Add tag</p> */}
                                  </div>
                                </div>
                                <hr className="hr-tag-ci" />
                              </div>
                            ))}
                          </>
                        ) : (
                          <p className="text-center-result">
                            No results found
                          </p>
                        )}
                      </div>
                    </div>
                    {loadOne ? (
                      <div className="dash-cancel-save-btns">
                        <Button
                          className="de_next"
                          onClick={() => setSkipOne((skip) => skip + 10)}
                        >
                          Load More
                        </Button>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="CI-cards-content">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px",
                      }}
                    >
                      Data Not Available{" "}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="prospect-aipath" style={{ width: "100%" }}>
                <p
                  className=""
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    padding: "20px",
                  }}
                >
                  To see information in this feed, ensure the Organization
                  is being tracked. You can track this Organization by
                  clicking the Action Button and selecting "Track," or by
                  navigating to the Competitive Intel section.{" "}
                </p>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <p className="simply-clicks-ci-details">
            Simply click on the{" "}
            <span className="simply-clicks-ci-details-span">
              Add Content
            </span>{" "}
            below to add your custom news search feed.
          </p>

          <div
            className="CI-cards-ciadded"
            onClick={handleCustomSearchData}
          >
            <AddCircleIcon
              style={{ color: "#001A54", width: 34, height: 34 }}
            />
            <p className="CI-card-content">Add Content</p>
          </div>
        </>
      )}
      {/* {loadOne && (
    <div className='dash-cancel-save-btns'>
      <Button className='de_next' onClick={() => setSkipOne(skip => skip + 10)}>
        Load More
      </Button>
    </div>
  )} */}
    </div>
      <Modal
        open={keywordAddModal}
        onClose={() => setKeywordAddModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="modal-head-heading-crossicon">
            <Typography
              id="modal-modal-title"
              variant="h6"
              className="enetr-name-heading-modal keyw-ci-modal"
            >
              Search Custom News Search
            </Typography>
            <ClearIcon
              style={{ cursor: "pointer" }}
              onClick={() => setKeywordAddModal(false)}
            />
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <LabelInput
              value={value}
              onChange={(e) => setValue(e?.target?.value)}
              placeholder={"Custom News Search Name"}
            />
            {value?.length > 1 ? (
              <div className="new-kw-ci">
                {allCustomSearchList
                  ?.filter((keyword) =>
                    keyword.custom_query_name
                      .toLowerCase()
                      .includes(value.toLowerCase()),
                  )
                  .map((keyword, index) => (
                    <div
                      className="w-ci-drw-xx"
                      //  onClick={() => getNews("date", keyword?.request_id)}
                      onClick={() => saveContentFeed(keyword)}
                      key={index}
                    >
                      {keyword.custom_query_name}{" "}
                    </div>
                  ))}
              </div>
            ) : null}
          </Typography>
          <Stack>
            <div className="button-cancel-save-modal">
              <Button
                variant="type"
                className="cancel-button-modal"
                onClick={() => {
                  setKeywordAddModal(false);
                }}
              >
                Cancel
              </Button>
            </div>
          </Stack>
        </Box>
      </Modal>{" "}
    </>
  );
};

export default CustomNewsSearchDetails;
